import React, { useEffect, useState, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRightIcon, ChevronLeftIcon, HomeIcon, UserIcon, MapPinIcon, ListIcon, EuroIcon, FileTextIcon, ImageIcon, MegaphoneIcon, CheckCircleIcon, SparklesIcon, PhoneIcon, MailIcon, BuildingIcon, UploadIcon, GripVerticalIcon, StarIcon, SaveIcon, AlertCircleIcon, ArrowLeftIcon, ArrowRightIcon, XIcon } from 'lucide-react';
import { useRental } from '../../contexts/RentalContext';
import { VisualListingWizard } from '../../components/rental/VisualListingWizard';
export function CreateListing() {
  const navigate = useNavigate();
  const {
    addListing
  } = useRental();
  const [wizardMode, setWizardMode] = useState<'classic' | 'visual' | null>(null);
  const [prospectingLead, setProspectingLead] = useState<any>(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [generatedDescription, setGeneratedDescription] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [uploadedImages, setUploadedImages] = useState<Array<{
    id: string;
    url: string;
    isPrimary: boolean;
  }>>([]);
  const [draggedImageId, setDraggedImageId] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    // Step 1: Property Type
    propertyType: 'apartament',
    propertyDestination: 'rezidential',
    transactionType: 'inchiriere',
    // Step 2: Owner Data
    ownerType: 'persoana_fizica',
    ownerName: '',
    ownerPhone: '',
    ownerEmail: '',
    companyCUI: '',
    companyName: '',
    acceptsStandardCommission: false,
    // Step 3: Location
    county: 'Bucuresti',
    locality: 'Sector 3',
    zone: '',
    fullAddress: '',
    // Step 4: Property Details
    rooms: '2',
    bedrooms: '1',
    bathrooms: '1',
    compartmentalization: 'decomandat',
    constructionYear: '',
    floor: '',
    totalFloors: '',
    buildingHeight: 'P+4',
    usefulSurface: '',
    builtSurface: '',
    balconySurface: '',
    terraceSurface: '',
    yardSurface: '',
    buildingType: 'bloc',
    constructionStage: 'finalizat',
    structure: 'beton',
    seismicRisk: 'fara-risc',
    petFriendly: false,
    keyAtAgency: false,
    openKitchen: false,
    nearMetro: false,
    parking: false,
    utilities: [] as string[],
    finishes: [] as string[],
    furniture: [] as string[],
    equipment: [] as string[],
    // Step 5: Price & Commission
    price: '',
    currency: 'EUR',
    includeTVA: false,
    negotiable: false,
    priceOnRequest: false,
    priceNotes: '',
    ownerCommission: '50',
    ownerCommissionAmount: '0',
    tenantCommission: '50',
    tenantCommissionAmount: '0',
    deposit: '1',
    utilitiesIncluded: 'extra',
    // Step 6: Description
    description: '',
    // Step 7: Images
    images: [] as string[],
    videoLink: '',
    // Step 8: Promotion
    storiaOlx: true,
    imobiliare: true,
    ownSite: true,
    availability: 'acum',
    availabilityDate: ''
  });
  const steps = [{
    number: 1,
    title: 'Tip proprietate',
    icon: HomeIcon
  }, {
    number: 2,
    title: 'Date proprietar',
    icon: UserIcon
  }, {
    number: 3,
    title: 'Locație & adresă',
    icon: MapPinIcon
  }, {
    number: 4,
    title: 'Detalii proprietate',
    icon: ListIcon
  }, {
    number: 5,
    title: 'Preț & comisionare',
    icon: EuroIcon
  }, {
    number: 6,
    title: 'Descriere AI',
    icon: FileTextIcon
  }, {
    number: 7,
    title: 'Imagini & editare AI',
    icon: ImageIcon
  }, {
    number: 8,
    title: 'Promovare & publicare',
    icon: MegaphoneIcon
  }];
  const propertyTypes = [{
    value: 'apartament',
    label: 'Apartament'
  }, {
    value: 'casa',
    label: 'Casă'
  }, {
    value: 'vila',
    label: 'Vilă'
  }, {
    value: 'teren',
    label: 'Teren'
  }, {
    value: 'spatiu-comercial',
    label: 'Spațiu comercial'
  }, {
    value: 'birouri',
    label: 'Birouri'
  }];
  const propertyDestinations = [{
    value: 'rezidential',
    label: 'Rezidențial'
  }, {
    value: 'comercial',
    label: 'Comercial'
  }, {
    value: 'birouri',
    label: 'Birouri'
  }, {
    value: 'vacanta',
    label: 'Vacanță'
  }];
  const counties = [{
    value: 'Bucuresti',
    label: 'București'
  }, {
    value: 'Ilfov',
    label: 'Ilfov'
  }, {
    value: 'Cluj',
    label: 'Cluj'
  }, {
    value: 'Timis',
    label: 'Timiș'
  }, {
    value: 'Brasov',
    label: 'Brașov'
  }, {
    value: 'Constanta',
    label: 'Constanța'
  }];
  const localities: any = {
    Bucuresti: [{
      value: 'Sector 1',
      label: 'Sector 1'
    }, {
      value: 'Sector 2',
      label: 'Sector 2'
    }, {
      value: 'Sector 3',
      label: 'Sector 3'
    }, {
      value: 'Sector 4',
      label: 'Sector 4'
    }, {
      value: 'Sector 5',
      label: 'Sector 5'
    }, {
      value: 'Sector 6',
      label: 'Sector 6'
    }],
    Ilfov: [{
      value: 'Voluntari',
      label: 'Voluntari'
    }, {
      value: 'Popesti-Leordeni',
      label: 'Popești-Leordeni'
    }, {
      value: 'Bragadiru',
      label: 'Bragadiru'
    }],
    Cluj: [{
      value: 'Cluj-Napoca',
      label: 'Cluj-Napoca'
    }, {
      value: 'Floresti',
      label: 'Florești'
    }]
  };
  const utilitiesList = ['Apă curentă', 'Canalizare', 'Electricitate', 'Gaze naturale', 'Încălzire centrală', 'Aer condiționat', 'Internet', 'TV cablu'];
  const finishesList = ['Gresie', 'Faianță', 'Parchet', 'Lambriuri', 'Tâmplărie PVC', 'Tâmplărie aluminiu', 'Uși interior lemn', 'Termopane'];
  const furnitureList = ['Mobilier living', 'Mobilier dormitor', 'Mobilier bucătărie', 'Canapea', 'Fotolii', 'Masă dining', 'Scaune', 'Dulap haine'];
  const equipmentList = ['Frigider', 'Aragaz', 'Cuptor', 'Hotă', 'Mașină spălat', 'Mașină spălat vase', 'Aspirator', 'Televizor', 'Microunde'];
  useEffect(() => {
    const leadData = sessionStorage.getItem('prospectingLead');
    if (leadData) {
      const lead = JSON.parse(leadData);
      setProspectingLead(lead);
      setFormData(prev => ({
        ...prev,
        zone: lead.zone || '',
        ownerPhone: lead.phone || '',
        rooms: lead.rooms?.toString() || '2',
        usefulSurface: lead.surface?.toString() || '',
        floor: lead.floor?.split('/')[0] || '',
        totalFloors: lead.floor?.split('/')[1] || '',
        price: lead.price?.toString() || ''
      }));
    }
  }, []);
  useEffect(() => {
    if (formData.price) {
      const price = parseFloat(formData.price);
      const ownerComm = (price * parseFloat(formData.ownerCommission) / 100 * 1.21).toFixed(0);
      const tenantComm = (price * parseFloat(formData.tenantCommission) / 100 * 1.21).toFixed(0);
      setFormData(prev => ({
        ...prev,
        ownerCommissionAmount: ownerComm,
        tenantCommissionAmount: tenantComm
      }));
    }
  }, [formData.price, formData.ownerCommission, formData.tenantCommission]);
  const handleImageUpload = () => {
    const newImages = Array.from({
      length: 3
    }, (_, i) => ({
      id: `img-${Date.now()}-${i}`,
      url: `https://via.placeholder.com/400x300?text=Image+${uploadedImages.length + i + 1}`,
      isPrimary: uploadedImages.length === 0 && i === 0
    }));
    setUploadedImages([...uploadedImages, ...newImages]);
  };
  const handleImageDragStart = (imageId: string) => {
    setDraggedImageId(imageId);
  };
  const handleImageDragOver = (e: React.DragEvent, targetImageId: string) => {
    e.preventDefault();
    if (!draggedImageId || draggedImageId === targetImageId) return;
    const draggedIndex = uploadedImages.findIndex(img => img.id === draggedImageId);
    const targetIndex = uploadedImages.findIndex(img => img.id === targetImageId);
    const newImages = [...uploadedImages];
    const [draggedImage] = newImages.splice(draggedIndex, 1);
    newImages.splice(targetIndex, 0, draggedImage);
    setUploadedImages(newImages);
  };
  const handleImageDragEnd = () => {
    setDraggedImageId(null);
  };
  const setPrimaryImage = (imageId: string) => {
    setUploadedImages(uploadedImages.map(img => ({
      ...img,
      isPrimary: img.id === imageId
    })));
  };
  const removeImage = (imageId: string) => {
    setUploadedImages(uploadedImages.filter(img => img.id !== imageId));
  };
  const handleGenerateDescription = () => {
    setIsGenerating(true);
    setTimeout(() => {
      const desc = `${formData.propertyType.charAt(0).toUpperCase() + formData.propertyType.slice(1)} modern cu ${formData.rooms} camere în zona ${formData.zone || 'centrală'}, perfect pentru o familie tânără sau profesioniști.

Proprietatea oferă ${formData.usefulSurface || formData.builtSurface || '50'} mp utili, amplasată la etajul ${formData.floor || '2'} din ${formData.totalFloors || '4'}, într-un ${formData.buildingType === 'bloc' ? 'bloc' : 'imobil'} ${formData.constructionYear ? `construit în ${formData.constructionYear}` : 'recent renovat'}. Spațiul este luminos, bine compartimentat (${formData.compartmentalization}) cu ${formData.bedrooms} dormitor${formData.bedrooms !== '1' ? 'e' : ''} și ${formData.bathrooms} baie/băi.

Dotări și utilități: ${formData.utilities.length > 0 ? formData.utilities.join(', ') : 'utilități complete'}. ${formData.openKitchen ? 'Bucătărie deschisă către living.' : ''} ${formData.parking ? 'Include loc de parcare.' : ''} ${formData.nearMetro ? 'Lângă stație de metrou.' : ''}

${formData.balconySurface ? `Balcon ${formData.balconySurface} mp.` : ''} ${formData.terraceSurface ? `Terasă ${formData.terraceSurface} mp.` : ''} ${formData.yardSurface ? `Curte/grădină ${formData.yardSurface} mp.` : ''}

Zona este liniștită, cu acces rapid la transport în comun, magazine, școli și parcuri. ${formData.petFriendly ? 'Se acceptă animale de companie.' : ''}

Preț: ${formData.priceOnRequest ? 'La cerere' : `${formData.price} ${formData.currency}/lună${formData.includeTVA ? ' + TVA' : ''}`}${formData.negotiable ? ' (negociabil)' : ''}.
${formData.deposit !== '0' ? `Garanție: ${formData.deposit} ${formData.deposit === '1' ? 'lună' : 'luni'} chirie.` : ''}

Disponibil ${formData.availability === 'acum' ? 'imediat' : `de la ${formData.availabilityDate}`}. Pentru programare vizionare, contactați-ne!`;
      setGeneratedDescription(desc);
      setFormData({
        ...formData,
        description: desc
      });
      setIsGenerating(false);
    }, 2000);
  };
  const handleRewriteShort = () => {
    if (!generatedDescription) return;
    setIsGenerating(true);
    setTimeout(() => {
      const shortDesc = `${formData.propertyType.charAt(0).toUpperCase() + formData.propertyType.slice(1)} ${formData.rooms} camere, ${formData.usefulSurface || formData.builtSurface} mp, zona ${formData.zone}. ${formData.compartmentalization === 'decomandat' ? 'Decomandat' : 'Semidecomandat'}, etaj ${formData.floor}/${formData.totalFloors}. ${formData.parking ? 'Parcare.' : ''} ${formData.nearMetro ? 'Lângă metrou.' : ''} Preț: ${formData.price} ${formData.currency}/lună. Disponibil ${formData.availability === 'acum' ? 'imediat' : formData.availabilityDate}.`;
      setGeneratedDescription(shortDesc);
      setFormData({
        ...formData,
        description: shortDesc
      });
      setIsGenerating(false);
    }, 1500);
  };
  const handleRewriteCommercial = () => {
    if (!generatedDescription) return;
    setIsGenerating(true);
    setTimeout(() => {
      const commercialDesc = `🏡 OPORTUNITATE EXCLUSIVĂ! ${formData.propertyType.toUpperCase()} ${formData.rooms} CAMERE - ${formData.zone.toUpperCase()}

✨ Caracteristici premium:
• ${formData.usefulSurface || formData.builtSurface} mp spațioși și luminoși
• Compartimentare ${formData.compartmentalization}
• ${formData.bedrooms} dormitor${formData.bedrooms !== '1' ? 'e' : ''} confortabil${formData.bedrooms !== '1' ? 'e' : ''}
• Etaj ${formData.floor} din ${formData.totalFloors}
${formData.parking ? '• ✅ LOC DE PARCARE inclus\n' : ''}${formData.nearMetro ? '• 🚇 La 5 minute de metrou\n' : ''}${formData.petFriendly ? '• 🐕 Pet friendly\n' : ''}
💰 Preț ATRACTIV: ${formData.price} ${formData.currency}/lună${formData.negotiable ? ' (NEGOCIABIL)' : ''}

📞 Sună ACUM pentru vizionare! Proprietatea se închiriază RAPID!`;
      setGeneratedDescription(commercialDesc);
      setFormData({
        ...formData,
        description: commercialDesc
      });
      setIsGenerating(false);
    }, 1500);
  };
  const handlePublish = (isDraft: boolean = false) => {
    const internalId = `P${Math.floor(10000 + Math.random() * 90000)}`;
    const newListing = {
      id: internalId,
      propertyType: formData.propertyType,
      zone: formData.zone,
      address: formData.fullAddress,
      rooms: parseInt(formData.rooms),
      surface: parseInt(formData.usefulSurface || formData.builtSurface),
      floor: formData.floor,
      price: parseInt(formData.price),
      currency: formData.currency,
      status: isDraft ? 'draft' as const : 'active' as const,
      description: formData.description,
      amenities: {
        furnished: formData.furniture.length > 0 ? 'mobilat' : 'nemobilat',
        heating: formData.utilities.includes('Încălzire centrală') ? 'centrala' : 'termoficare',
        parking: formData.parking,
        balcony: !!formData.balconySurface,
        pets: formData.petFriendly
      },
      images: uploadedImages.map(img => img.url),
      createdAt: new Date().toISOString(),
      activatedAt: isDraft ? undefined : new Date().toISOString(),
      ownerPhone: formData.ownerPhone,
      viewingsCount: 0,
      leadsCount: 0
    };
    addListing(newListing);
    if (prospectingLead) {
      sessionStorage.removeItem('prospectingLead');
    }
    const message = isDraft ? `✅ Anunțul a fost salvat ca draft (ID: ${internalId}). Îl poți găsi în modulul "Anunțuri" și îl poți edita oricând.` : `✅ Anunțul a fost creat cu succes (ID: ${internalId})! Proprietatea va rămâne activă 30 de zile, după care va trece automat în status "Follow-up". Îl poți găsi în modulul "Anunțuri" și îl poți edita oricând.`;
    alert(message);
    navigate('/inchiriere/anunturi');
  };
  const nextStep = () => {
    if (currentStep < 8) setCurrentStep(currentStep + 1);
  };
  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  const toggleArrayItem = (array: string[], item: string) => {
    return array.includes(item) ? array.filter(i => i !== item) : [...array, item];
  };
  const handleVisualWizardComplete = (data: any) => {
    const internalId = `P${Math.floor(10000 + Math.random() * 90000)}`;
    const newListing = {
      id: internalId,
      propertyType: data.propertyType,
      zone: data.zone,
      address: '',
      rooms: data.rooms,
      surface: data.surface,
      floor: '',
      price: data.price,
      currency: 'EUR',
      status: 'active' as const,
      description: data.description,
      amenities: {
        furnished: 'mobilat',
        heating: 'centrala',
        parking: false,
        balcony: false,
        pets: false
      },
      images: data.images,
      createdAt: new Date().toISOString(),
      activatedAt: new Date().toISOString(),
      ownerPhone: '',
      viewingsCount: 0,
      leadsCount: 0
    };
    addListing(newListing);
    alert(`✅ Listing created successfully (ID: ${internalId})!`);
    navigate('/inchiriere/anunturi');
  };
  if (wizardMode === 'visual') {
    return <VisualListingWizard onClose={() => setWizardMode(null)} onComplete={handleVisualWizardComplete} data-id="element-9553" />;
  }
  if (wizardMode === null) {
    return <div className="w-full min-h-screen bg-[#F1F1F1]" data-id="element-9554">
        <div className="bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white py-12" data-id="element-9555">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9556">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-9557">
              <h1 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-9558">
                Creare anunț proprietate
              </h1>
              <p className="text-gray-300" data-id="element-9559">
                Alege modul de creare preferat pentru anunțul tău
              </p>
            </motion.div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-9560">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-9561">
            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4
          }} onClick={() => setWizardMode('visual')} className="group relative overflow-hidden rounded-xl bg-white shadow-md hover:shadow-xl transition-all" data-id="element-9562">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 opacity-90" data-id="element-9563" />
              <div className="relative p-8 text-white" data-id="element-9564">
                <div className="mb-6" data-id="element-9565">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform" data-id="element-9566">
                    <SparklesIcon className="w-8 h-8" data-id="element-9567" />
                  </div>
                  <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-semibold mb-4" data-id="element-9568">
                    ✨ NOU
                  </span>
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-9569">
                  Visual Story Builder
                </h3>
                <p className="text-white/90 mb-6" data-id="element-9570">
                  Experiență imersivă, stil magazin cu carduri full-screen,
                  hărți interactive și previzualizări live
                </p>
                <ul className="text-left space-y-2 text-white/80 mb-6 text-sm" data-id="element-9571">
                  <li className="flex items-center space-x-2" data-id="element-9572">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9573" />
                    <span data-id="element-9574">Selecție vizuală tip proprietate</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-9575">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9576" />
                    <span data-id="element-9577">Hartă interactivă pentru locație</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-9578">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9579" />
                    <span data-id="element-9580">Constructor vizual camere cu drag & drop</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-9581">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9582" />
                    <span data-id="element-9583">Previzualizare live Storia/OLX</span>
                  </li>
                </ul>
                <div className="flex items-center justify-center space-x-2 font-bold" data-id="element-9584">
                  <span data-id="element-9585">Începe crearea</span>
                  <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-2 transition-transform" data-id="element-9586" />
                </div>
              </div>
            </motion.button>

            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1
          }} onClick={() => setWizardMode('classic')} className="group relative overflow-hidden rounded-xl bg-white shadow-md hover:shadow-xl transition-all" data-id="element-9587">
              <div className="absolute inset-0 bg-gradient-to-br from-[#357BEB] to-[#21A366] opacity-90" data-id="element-9588" />
              <div className="relative p-8 text-white" data-id="element-9589">
                <div className="mb-6" data-id="element-9590">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform" data-id="element-9591">
                    <ListIcon className="w-8 h-8" data-id="element-9592" />
                  </div>
                  <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-semibold mb-4" data-id="element-9593">
                    CLASIC
                  </span>
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-9594">
                  Wizard formular detaliat
                </h3>
                <p className="text-white/90 mb-6" data-id="element-9595">
                  Formular complet pas-cu-pas cu toate detaliile proprietății,
                  prețuri și opțiuni de promovare
                </p>
                <ul className="text-left space-y-2 text-white/80 mb-6 text-sm" data-id="element-9596">
                  <li className="flex items-center space-x-2" data-id="element-9597">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9598" />
                    <span data-id="element-9599">Informații complete proprietate</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-9600">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9601" />
                    <span data-id="element-9602">Date proprietar & configurare comisioane</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-9603">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9604" />
                    <span data-id="element-9605">Specificații detaliate proprietate</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-9606">
                    <CheckCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-9607" />
                    <span data-id="element-9608">Generator descriere AI</span>
                  </li>
                </ul>
                <div className="flex items-center justify-center space-x-2 font-bold" data-id="element-9609">
                  <span data-id="element-9610">Folosește modul clasic</span>
                  <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-2 transition-transform" data-id="element-9611" />
                </div>
              </div>
            </motion.button>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-center mt-8" data-id="element-9612">
            <Link to="/inchiriere" className="text-gray-600 hover:text-gray-900 font-medium inline-flex items-center space-x-2" data-id="element-9613">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-9614" />
              <span data-id="element-9615">Înapoi la Dashboard</span>
            </Link>
          </motion.div>
        </div>
      </div>;
  }
  return <div className="w-full min-h-screen bg-[#F1F1F1]" data-id="element-9616">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white py-12" data-id="element-9617">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9618">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-9619">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-9620">
              <div data-id="element-9621">
                <h1 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-9622">
                  Creare anunț proprietate
                </h1>
                <p className="text-gray-300" data-id="element-9623">
                  Completează datele în 8 pași simpli pentru a crea un anunț
                  profesional
                </p>
              </div>
              <button onClick={() => setWizardMode(null)} className="flex items-center space-x-2 text-white hover:text-gray-200 font-medium transition-colors whitespace-nowrap" data-id="element-9624">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-9625" />
                <span data-id="element-9626">Schimbă modul</span>
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-9627">
        {/* Prospecting Lead Banner */}
        {prospectingLead && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-gradient-to-r from-[#21A366] to-[#1a8555] rounded-xl p-6 text-white mb-6 shadow-md" data-id="element-9628">
            <div className="flex items-start space-x-3" data-id="element-9629">
              <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-9630" />
              <div className="flex-1" data-id="element-9631">
                <h3 className="text-lg font-bold mb-2" data-id="element-9632">
                  ✅ Lead de prospectare detectat!
                </h3>
                <p className="text-white text-opacity-90 mb-3" data-id="element-9633">
                  Datele din leadul{' '}
                  <strong data-id="element-9634">{prospectingLead.prospectId}</strong> au fost
                  autocompletate în formular.
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-3" data-id="element-9635">
                  <div data-id="element-9636">
                    <p className="text-xs text-white text-opacity-70" data-id="element-9637">Zonă</p>
                    <p className="font-bold" data-id="element-9638">{prospectingLead.zone}</p>
                  </div>
                  <div data-id="element-9639">
                    <p className="text-xs text-white text-opacity-70" data-id="element-9640">Camere</p>
                    <p className="font-bold" data-id="element-9641">{prospectingLead.rooms}</p>
                  </div>
                  <div data-id="element-9642">
                    <p className="text-xs text-white text-opacity-70" data-id="element-9643">
                      Suprafață
                    </p>
                    <p className="font-bold" data-id="element-9644">{prospectingLead.surface} mp</p>
                  </div>
                  <div data-id="element-9645">
                    <p className="text-xs text-white text-opacity-70" data-id="element-9646">Preț</p>
                    <p className="font-bold" data-id="element-9647">{prospectingLead.price} €</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>}

        {/* Progress Steps */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 mb-6" data-id="element-9648">
          <div className="flex items-center justify-between overflow-x-auto" data-id="element-9649">
            {steps.map((step, index) => {
            const Icon = step.icon;
            const isActive = currentStep === step.number;
            const isCompleted = currentStep > step.number;
            return <Fragment key={step.number} data-id="element-9650">
                  <div className="flex flex-col items-center min-w-[100px]" data-id="element-9651">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${isActive ? 'bg-[#357BEB] text-white scale-110 shadow-lg' : isCompleted ? 'bg-[#21A366] text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-9652">
                      {isCompleted ? <CheckCircleIcon className="w-6 h-6" data-id="element-9653" /> : <Icon className="w-6 h-6" data-id="element-9654" />}
                    </div>
                    <span className={`text-xs mt-2 font-medium text-center ${isActive ? 'text-[#357BEB]' : 'text-gray-500'}`} data-id="element-9655">
                      {step.title}
                    </span>
                  </div>
                  {index < steps.length - 1 && <div className={`flex-1 h-1 mx-2 rounded transition-all ${isCompleted ? 'bg-[#21A366]' : 'bg-gray-200'}`} data-id="element-9656" />}
                </Fragment>;
          })}
          </div>
        </div>

        {/* AI Assistant Banner */}
        <div className="bg-gradient-to-r from-purple-50 to-blue-50 border-2 border-purple-200 rounded-xl p-4 mb-6" data-id="element-9657">
          <div className="flex items-start space-x-3" data-id="element-9658">
            <SparklesIcon className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-9659" />
            <div data-id="element-9660">
              <p className="text-sm text-gray-700" data-id="element-9661">
                <strong data-id="element-9662">Asistent AI activ:</strong> Voi genera automat descrieri
                profesionale, sugestii de preț, și voi optimiza anunțul pentru
                platformele externe.
              </p>
            </div>
          </div>
        </div>

        {/* Step Content */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8" data-id="element-9663">
          <AnimatePresence mode="wait" data-id="element-9664">
            <motion.div key={currentStep} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-9665">
              {/* STEP 1: Property Type */}
              {currentStep === 1 && <div className="space-y-6" data-id="element-9666">
                  <div data-id="element-9667">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9668">
                      Tip Proprietate
                    </h2>
                    <p className="text-gray-600" data-id="element-9669">
                      Selectează tipul și destinația proprietății
                    </p>
                  </div>

                  <div data-id="element-9670">
                    <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-9671">
                      Tip proprietate *
                    </label>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-9672">
                      {propertyTypes.map(type => <button key={type.value} onClick={() => setFormData({
                    ...formData,
                    propertyType: type.value
                  })} className={`p-4 rounded-xl border-2 transition-all ${formData.propertyType === type.value ? 'border-[#357BEB] bg-blue-50 shadow-md' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-9673">
                          <HomeIcon className="w-8 h-8 mx-auto mb-2 text-[#357BEB]" data-id="element-9674" />
                          <p className="font-semibold text-gray-900 text-center" data-id="element-9675">
                            {type.label}
                          </p>
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-9676">
                    <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-9677">
                      Destinație proprietate *
                    </label>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-9678">
                      {propertyDestinations.map(dest => <button key={dest.value} onClick={() => setFormData({
                    ...formData,
                    propertyDestination: dest.value
                  })} className={`p-4 rounded-xl border-2 transition-all ${formData.propertyDestination === dest.value ? 'border-[#357BEB] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-9679">
                          <p className="font-semibold text-gray-900 text-center" data-id="element-9680">
                            {dest.label}
                          </p>
                        </button>)}
                    </div>
                  </div>
                </div>}

              {/* STEP 2: Owner Data */}
              {currentStep === 2 && <div className="space-y-6" data-id="element-9681">
                  <div data-id="element-9682">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9683">
                      Date Proprietar
                    </h2>
                    <p className="text-gray-600" data-id="element-9684">
                      Informații despre proprietarul imobilului
                    </p>
                  </div>

                  <div data-id="element-9685">
                    <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-9686">
                      Tip proprietar *
                    </label>
                    <div className="grid grid-cols-2 gap-4" data-id="element-9687">
                      <button onClick={() => setFormData({
                    ...formData,
                    ownerType: 'persoana_fizica'
                  })} className={`p-6 rounded-xl border-2 transition-all ${formData.ownerType === 'persoana_fizica' ? 'border-[#357BEB] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-9688">
                        <UserIcon className="w-8 h-8 mx-auto mb-2 text-[#357BEB]" data-id="element-9689" />
                        <p className="font-bold text-gray-900 text-center" data-id="element-9690">
                          Persoană Fizică
                        </p>
                      </button>
                      <button onClick={() => setFormData({
                    ...formData,
                    ownerType: 'persoana_juridica'
                  })} className={`p-6 rounded-xl border-2 transition-all ${formData.ownerType === 'persoana_juridica' ? 'border-[#357BEB] bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-9691">
                        <BuildingIcon className="w-8 h-8 mx-auto mb-2 text-[#357BEB]" data-id="element-9692" />
                        <p className="font-bold text-gray-900 text-center" data-id="element-9693">
                          Persoană Juridică
                        </p>
                      </button>
                    </div>
                  </div>

                  {formData.ownerType === 'persoana_fizica' ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9694">
                      <div data-id="element-9695">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9696">
                          Nume complet *
                        </label>
                        <input type="text" value={formData.ownerName} onChange={e => setFormData({
                    ...formData,
                    ownerName: e.target.value
                  })} placeholder="Ion Popescu" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9697" />
                      </div>
                      <div data-id="element-9698">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9699">
                          Telefon *
                        </label>
                        <input type="tel" value={formData.ownerPhone} onChange={e => setFormData({
                    ...formData,
                    ownerPhone: e.target.value
                  })} placeholder="0721234567" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9700" />
                      </div>
                      <div className="md:col-span-2" data-id="element-9701">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9702">
                          Email (opțional)
                        </label>
                        <input type="email" value={formData.ownerEmail} onChange={e => setFormData({
                    ...formData,
                    ownerEmail: e.target.value
                  })} placeholder="contact@email.com" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9703" />
                      </div>
                    </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9704">
                      <div data-id="element-9705">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9706">
                          Denumire companie *
                        </label>
                        <input type="text" value={formData.companyName} onChange={e => setFormData({
                    ...formData,
                    companyName: e.target.value
                  })} placeholder="SC Exemplu SRL" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9707" />
                      </div>
                      <div data-id="element-9708">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9709">
                          CUI *
                        </label>
                        <input type="text" value={formData.companyCUI} onChange={e => setFormData({
                    ...formData,
                    companyCUI: e.target.value
                  })} placeholder="RO12345678" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9710" />
                      </div>
                      <div data-id="element-9711">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9712">
                          Persoană contact *
                        </label>
                        <input type="text" value={formData.ownerName} onChange={e => setFormData({
                    ...formData,
                    ownerName: e.target.value
                  })} placeholder="Ion Popescu" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9713" />
                      </div>
                      <div data-id="element-9714">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9715">
                          Telefon *
                        </label>
                        <input type="tel" value={formData.ownerPhone} onChange={e => setFormData({
                    ...formData,
                    ownerPhone: e.target.value
                  })} placeholder="0721234567" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9716" />
                      </div>
                      <div className="md:col-span-2" data-id="element-9717">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9718">
                          Email companie *
                        </label>
                        <input type="email" value={formData.ownerEmail} onChange={e => setFormData({
                    ...formData,
                    ownerEmail: e.target.value
                  })} placeholder="office@companie.ro" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9719" />
                      </div>
                    </div>}

                  <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-4" data-id="element-9720">
                    <label className="flex items-start space-x-3 cursor-pointer" data-id="element-9721">
                      <input type="checkbox" checked={formData.acceptsStandardCommission} onChange={e => setFormData({
                    ...formData,
                    acceptsStandardCommission: e.target.checked
                  })} className="w-5 h-5 text-[#357BEB] rounded mt-0.5" data-id="element-9722" />
                      <span className="text-sm text-gray-700" data-id="element-9723">
                        <strong data-id="element-9724">
                          Proprietarul acceptă comisionul standard
                        </strong>{' '}
                        (50% proprietar + 50% chiriaș)
                      </span>
                    </label>
                  </div>
                </div>}

              {/* STEP 3: Location */}
              {currentStep === 3 && <div className="space-y-6" data-id="element-9725">
                  <div data-id="element-9726">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9727">
                      Locație & Adresă
                    </h2>
                    <p className="text-gray-600" data-id="element-9728">
                      Unde este amplasată proprietatea
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9729">
                    <div data-id="element-9730">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9731">
                        Județ *
                      </label>
                      <select value={formData.county} onChange={e => setFormData({
                    ...formData,
                    county: e.target.value,
                    locality: localities[e.target.value]?.[0]?.value || ''
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9732">
                        {counties.map(county => <option key={county.value} value={county.value} data-id="element-9733">
                            {county.label}
                          </option>)}
                      </select>
                    </div>
                    <div data-id="element-9734">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9735">
                        Localitate *
                      </label>
                      <select value={formData.locality} onChange={e => setFormData({
                    ...formData,
                    locality: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9736">
                        {(localities[formData.county] || []).map((loc: any) => <option key={loc.value} value={loc.value} data-id="element-9737">
                            {loc.label}
                          </option>)}
                      </select>
                    </div>
                  </div>

                  <div data-id="element-9738">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9739">
                      Zonă / Cartier *
                    </label>
                    <input type="text" value={formData.zone} onChange={e => setFormData({
                  ...formData,
                  zone: e.target.value
                })} placeholder="Ex: Titan, Militari, Centru..." className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9740" />
                  </div>

                  <div data-id="element-9741">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9742">
                      Adresă completă *
                    </label>
                    <input type="text" value={formData.fullAddress} onChange={e => setFormData({
                  ...formData,
                  fullAddress: e.target.value
                })} placeholder="Strada, număr, bloc, scară, etaj, apartament" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9743" />
                    <p className="text-xs text-gray-500 mt-2" data-id="element-9744">
                      💡 Adresa exactă nu va fi afișată public. Doar zona și
                      cartierul vor fi vizibile în anunț.
                    </p>
                  </div>
                </div>}

              {/* STEP 4: Property Details */}
              {currentStep === 4 && <div className="space-y-6" data-id="element-9745">
                  <div data-id="element-9746">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9747">
                      Detalii Proprietate
                    </h2>
                    <p className="text-gray-600" data-id="element-9748">Caracteristici și dotări</p>
                  </div>

                  {/* Basic Info */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-9749">
                    <div data-id="element-9750">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9751">
                        Camere *
                      </label>
                      <input type="number" value={formData.rooms} onChange={e => setFormData({
                    ...formData,
                    rooms: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9752" />
                    </div>
                    <div data-id="element-9753">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9754">
                        Dormitoare
                      </label>
                      <input type="number" value={formData.bedrooms} onChange={e => setFormData({
                    ...formData,
                    bedrooms: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9755" />
                    </div>
                    <div data-id="element-9756">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9757">
                        Băi
                      </label>
                      <input type="number" value={formData.bathrooms} onChange={e => setFormData({
                    ...formData,
                    bathrooms: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9758" />
                    </div>
                    <div data-id="element-9759">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9760">
                        An construcție
                      </label>
                      <input type="number" value={formData.constructionYear} onChange={e => setFormData({
                    ...formData,
                    constructionYear: e.target.value
                  })} placeholder="2010" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9761" />
                    </div>
                  </div>

                  {/* Surfaces */}
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-9762">
                    <div data-id="element-9763">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9764">
                        Suprafață utilă (mp) *
                      </label>
                      <input type="number" value={formData.usefulSurface} onChange={e => setFormData({
                    ...formData,
                    usefulSurface: e.target.value
                  })} placeholder="52" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9765" />
                    </div>
                    <div data-id="element-9766">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9767">
                        Suprafață construită (mp)
                      </label>
                      <input type="number" value={formData.builtSurface} onChange={e => setFormData({
                    ...formData,
                    builtSurface: e.target.value
                  })} placeholder="60" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9768" />
                    </div>
                    <div data-id="element-9769">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9770">
                        Balcon (mp)
                      </label>
                      <input type="number" value={formData.balconySurface} onChange={e => setFormData({
                    ...formData,
                    balconySurface: e.target.value
                  })} placeholder="4" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9771" />
                    </div>
                  </div>

                  {/* Floor & Compartmentalization */}
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-9772">
                    <div data-id="element-9773">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9774">
                        Etaj
                      </label>
                      <input type="text" value={formData.floor} onChange={e => setFormData({
                    ...formData,
                    floor: e.target.value
                  })} placeholder="3" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9775" />
                    </div>
                    <div data-id="element-9776">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9777">
                        Total etaje
                      </label>
                      <input type="text" value={formData.totalFloors} onChange={e => setFormData({
                    ...formData,
                    totalFloors: e.target.value
                  })} placeholder="4" className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9778" />
                    </div>
                    <div data-id="element-9779">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9780">
                        Compartimentare
                      </label>
                      <select value={formData.compartmentalization} onChange={e => setFormData({
                    ...formData,
                    compartmentalization: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9781">
                        <option value="decomandat" data-id="element-9782">Decomandat</option>
                        <option value="semidecomandat" data-id="element-9783">Semidecomandat</option>
                        <option value="circular" data-id="element-9784">Circular</option>
                      </select>
                    </div>
                  </div>

                  {/* Checkboxes */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-9785">
                    {[{
                  key: 'petFriendly',
                  label: 'Animale acceptate'
                }, {
                  key: 'parking',
                  label: 'Loc parcare'
                }, {
                  key: 'openKitchen',
                  label: 'Bucătărie deschisă'
                }, {
                  key: 'nearMetro',
                  label: 'Lângă metrou'
                }].map(item => <label key={item.key} className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100" data-id="element-9786">
                        <input type="checkbox" checked={formData[item.key as keyof typeof formData] as boolean} onChange={e => setFormData({
                    ...formData,
                    [item.key]: e.target.checked
                  })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9787" />
                        <span className="text-sm font-medium text-gray-700" data-id="element-9788">
                          {item.label}
                        </span>
                      </label>)}
                  </div>

                  {/* Multi-select Lists */}
                  <div className="space-y-4" data-id="element-9789">
                    <div data-id="element-9790">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9791">
                        Utilități
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-id="element-9792">
                        {utilitiesList.map(utility => <label key={utility} className="flex items-center space-x-2 p-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100" data-id="element-9793">
                            <input type="checkbox" checked={formData.utilities.includes(utility)} onChange={() => setFormData({
                        ...formData,
                        utilities: toggleArrayItem(formData.utilities, utility)
                      })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9794" />
                            <span className="text-sm text-gray-700" data-id="element-9795">
                              {utility}
                            </span>
                          </label>)}
                      </div>
                    </div>

                    <div data-id="element-9796">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9797">
                        Finisaje
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-id="element-9798">
                        {finishesList.map(finish => <label key={finish} className="flex items-center space-x-2 p-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100" data-id="element-9799">
                            <input type="checkbox" checked={formData.finishes.includes(finish)} onChange={() => setFormData({
                        ...formData,
                        finishes: toggleArrayItem(formData.finishes, finish)
                      })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9800" />
                            <span className="text-sm text-gray-700" data-id="element-9801">
                              {finish}
                            </span>
                          </label>)}
                      </div>
                    </div>

                    <div data-id="element-9802">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9803">
                        Mobilier
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-id="element-9804">
                        {furnitureList.map(item => <label key={item} className="flex items-center space-x-2 p-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100" data-id="element-9805">
                            <input type="checkbox" checked={formData.furniture.includes(item)} onChange={() => setFormData({
                        ...formData,
                        furniture: toggleArrayItem(formData.furniture, item)
                      })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9806" />
                            <span className="text-sm text-gray-700" data-id="element-9807">
                              {item}
                            </span>
                          </label>)}
                      </div>
                    </div>

                    <div data-id="element-9808">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9809">
                        Echipamente
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-id="element-9810">
                        {equipmentList.map(equip => <label key={equip} className="flex items-center space-x-2 p-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100" data-id="element-9811">
                            <input type="checkbox" checked={formData.equipment.includes(equip)} onChange={() => setFormData({
                        ...formData,
                        equipment: toggleArrayItem(formData.equipment, equip)
                      })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9812" />
                            <span className="text-sm text-gray-700" data-id="element-9813">
                              {equip}
                            </span>
                          </label>)}
                      </div>
                    </div>
                  </div>
                </div>}

              {/* STEP 5: Price & Commission */}
              {currentStep === 5 && <div className="space-y-6" data-id="element-9814">
                  <div data-id="element-9815">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9816">
                      Preț & Comisionare
                    </h2>
                    <p className="text-gray-600" data-id="element-9817">
                      Stabilește prețul și condițiile financiare
                    </p>
                  </div>

                  {/* Price */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9818">
                    <div className="md:col-span-2" data-id="element-9819">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9820">
                        Preț chirie lunară *
                      </label>
                      <input type="number" value={formData.price} onChange={e => setFormData({
                    ...formData,
                    price: e.target.value
                  })} placeholder="450" className="w-full px-4 py-3 text-2xl font-bold border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9821" />
                    </div>
                    <div data-id="element-9822">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9823">
                        Monedă
                      </label>
                      <select value={formData.currency} onChange={e => setFormData({
                    ...formData,
                    currency: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9824">
                        <option value="EUR" data-id="element-9825">EUR (€)</option>
                        <option value="RON" data-id="element-9826">RON (lei)</option>
                      </select>
                    </div>
                  </div>

                  {/* Price Options */}
                  <div className="flex flex-wrap gap-4" data-id="element-9827">
                    <label className="flex items-center space-x-2 cursor-pointer" data-id="element-9828">
                      <input type="checkbox" checked={formData.negotiable} onChange={e => setFormData({
                    ...formData,
                    negotiable: e.target.checked
                  })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9829" />
                      <span className="text-sm text-gray-700" data-id="element-9830">
                        Preț negociabil
                      </span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer" data-id="element-9831">
                      <input type="checkbox" checked={formData.includeTVA} onChange={e => setFormData({
                    ...formData,
                    includeTVA: e.target.checked
                  })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9832" />
                      <span className="text-sm text-gray-700" data-id="element-9833">Include TVA</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer" data-id="element-9834">
                      <input type="checkbox" checked={formData.priceOnRequest} onChange={e => setFormData({
                    ...formData,
                    priceOnRequest: e.target.checked
                  })} className="w-4 h-4 text-[#357BEB] rounded" data-id="element-9835" />
                      <span className="text-sm text-gray-700" data-id="element-9836">
                        Preț la cerere
                      </span>
                    </label>
                  </div>

                  {/* Deposit & Utilities */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9837">
                    <div data-id="element-9838">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9839">
                        Garanție (luni chirie)
                      </label>
                      <select value={formData.deposit} onChange={e => setFormData({
                    ...formData,
                    deposit: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9840">
                        <option value="0" data-id="element-9841">Fără garanție</option>
                        <option value="1" data-id="element-9842">1 lună</option>
                        <option value="2" data-id="element-9843">2 luni</option>
                        <option value="3" data-id="element-9844">3 luni</option>
                      </select>
                    </div>
                    <div data-id="element-9845">
                      <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9846">
                        Utilități
                      </label>
                      <select value={formData.utilitiesIncluded} onChange={e => setFormData({
                    ...formData,
                    utilitiesIncluded: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9847">
                        <option value="extra" data-id="element-9848">Extra (plătite separat)</option>
                        <option value="included" data-id="element-9849">Incluse în preț</option>
                      </select>
                    </div>
                  </div>

                  {/* Commission */}
                  <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6" data-id="element-9850">
                    <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-9851">
                      Comisioane Agenție
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-9852">
                      <div data-id="element-9853">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9854">
                          Comision proprietar (%)
                        </label>
                        <input type="number" value={formData.ownerCommission} onChange={e => setFormData({
                      ...formData,
                      ownerCommission: e.target.value
                    })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9855" />
                        <p className="text-sm text-gray-600 mt-2" data-id="element-9856">
                          Valoare:{' '}
                          <strong data-id="element-9857">
                            {formData.ownerCommissionAmount} {formData.currency}
                          </strong>{' '}
                          (cu TVA 21%)
                        </p>
                      </div>
                      <div data-id="element-9858">
                        <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9859">
                          Comision chiriaș (%)
                        </label>
                        <input type="number" value={formData.tenantCommission} onChange={e => setFormData({
                      ...formData,
                      tenantCommission: e.target.value
                    })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9860" />
                        <p className="text-sm text-gray-600 mt-2" data-id="element-9861">
                          Valoare:{' '}
                          <strong data-id="element-9862">
                            {formData.tenantCommissionAmount}{' '}
                            {formData.currency}
                          </strong>{' '}
                          (cu TVA 21%)
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Availability */}
                  <div data-id="element-9863">
                    <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-9864">
                      Disponibilitate
                    </label>
                    <div className="space-y-3" data-id="element-9865">
                      <label className="flex items-center space-x-2" data-id="element-9866">
                        <input type="radio" value="acum" checked={formData.availability === 'acum'} onChange={e => setFormData({
                      ...formData,
                      availability: e.target.value
                    })} className="w-4 h-4 text-[#357BEB]" data-id="element-9867" />
                        <span className="text-sm text-gray-700" data-id="element-9868">
                          Disponibil imediat
                        </span>
                      </label>
                      <label className="flex items-center space-x-2" data-id="element-9869">
                        <input type="radio" value="data" checked={formData.availability === 'data'} onChange={e => setFormData({
                      ...formData,
                      availability: e.target.value
                    })} className="w-4 h-4 text-[#357BEB]" data-id="element-9870" />
                        <span className="text-sm text-gray-700" data-id="element-9871">
                          De la data:
                        </span>
                      </label>
                      {formData.availability === 'data' && <input type="date" value={formData.availabilityDate} onChange={e => setFormData({
                    ...formData,
                    availabilityDate: e.target.value
                  })} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9872" />}
                    </div>
                  </div>
                </div>}

              {/* STEP 6: AI Description */}
              {currentStep === 6 && <div className="space-y-6" data-id="element-9873">
                  <div data-id="element-9874">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9875">
                      Descriere AI
                    </h2>
                    <p className="text-gray-600" data-id="element-9876">
                      Generează automat o descriere profesională
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-purple-50 to-blue-50 border-2 border-purple-200 rounded-xl p-6" data-id="element-9877">
                    <div className="flex items-center justify-between mb-4" data-id="element-9878">
                      <div className="flex items-center space-x-3" data-id="element-9879">
                        <SparklesIcon className="w-6 h-6 text-purple-600" data-id="element-9880" />
                        <h3 className="text-lg font-bold text-gray-900" data-id="element-9881">
                          Generator Descriere AI
                        </h3>
                      </div>
                      <button onClick={handleGenerateDescription} disabled={isGenerating} className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg font-semibold hover:shadow-lg transition-all disabled:opacity-50" data-id="element-9882">
                        <SparklesIcon className="w-5 h-5" data-id="element-9883" />
                        <span data-id="element-9884">
                          {isGenerating ? 'Generez...' : 'Generează descriere'}
                        </span>
                      </button>
                    </div>
                    <p className="text-sm text-gray-600" data-id="element-9885">
                      Asistentul AI va crea o descriere completă bazată pe
                      datele introduse până acum.
                    </p>
                  </div>

                  {generatedDescription && <div className="space-y-4" data-id="element-9886">
                      <div className="flex items-center justify-between" data-id="element-9887">
                        <h3 className="text-lg font-bold text-gray-900" data-id="element-9888">
                          Descriere generată
                        </h3>
                        <div className="flex space-x-2" data-id="element-9889">
                          <button onClick={handleRewriteShort} disabled={isGenerating} className="px-4 py-2 border-2 border-[#357BEB] text-[#357BEB] rounded-lg text-sm font-semibold hover:bg-[#357BEB] hover:text-white transition-all disabled:opacity-50" data-id="element-9890">
                            Versiune scurtă
                          </button>
                          <button onClick={handleRewriteCommercial} disabled={isGenerating} className="px-4 py-2 border-2 border-[#21A366] text-[#21A366] rounded-lg text-sm font-semibold hover:bg-[#21A366] hover:text-white transition-all disabled:opacity-50" data-id="element-9891">
                            Versiune comercială
                          </button>
                        </div>
                      </div>
                      <textarea value={formData.description} onChange={e => setFormData({
                  ...formData,
                  description: e.target.value
                })} rows={16} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB] resize-none" data-id="element-9892" />
                      <p className="text-sm text-gray-500" data-id="element-9893">
                        {formData.description.length} caractere
                      </p>
                    </div>}

                  {!generatedDescription && <div className="text-center py-12" data-id="element-9894">
                      <SparklesIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-9895" />
                      <p className="text-gray-500" data-id="element-9896">
                        Apasă butonul "Generează descriere" pentru a crea
                        automat o descriere profesională
                      </p>
                    </div>}
                </div>}

              {/* STEP 7: Images */}
              {currentStep === 7 && <div className="space-y-6" data-id="element-9897">
                  <div data-id="element-9898">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9899">
                      Imagini & Editare AI
                    </h2>
                    <p className="text-gray-600" data-id="element-9900">
                      Încarcă fotografii ale proprietății
                    </p>
                  </div>

                  <div onClick={handleImageUpload} className="border-4 border-dashed border-gray-300 rounded-xl p-12 text-center cursor-pointer hover:border-[#357BEB] transition-all bg-gray-50 hover:bg-blue-50" data-id="element-9901">
                    <UploadIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" data-id="element-9902" />
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-9903">
                      Încarcă fotografii
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-9904">
                      Click pentru a adăuga imagini (minim 5 recomandate)
                    </p>
                    <button type="button" className="px-6 py-3 bg-[#357BEB] text-white rounded-lg font-semibold hover:bg-[#2868d8] transition-colors" data-id="element-9905">
                      Selectează fișiere
                    </button>
                    <p className="text-sm text-gray-500 mt-4" data-id="element-9906">
                      JPG, PNG până la 10MB per imagine
                    </p>
                  </div>

                  {uploadedImages.length > 0 && <div className="space-y-4" data-id="element-9907">
                      <div className="flex items-center justify-between" data-id="element-9908">
                        <h3 className="text-lg font-bold text-gray-900" data-id="element-9909">
                          Imagini încărcate ({uploadedImages.length})
                        </h3>
                        <p className="text-sm text-gray-500" data-id="element-9910">
                          💡 Trage imaginile pentru a le reordona
                        </p>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-9911">
                        {uploadedImages.map((image, index) => <div key={image.id} draggable onDragStart={() => handleImageDragStart(image.id)} onDragOver={e => handleImageDragOver(e, image.id)} onDragEnd={handleImageDragEnd} className={`group relative rounded-xl overflow-hidden border-2 ${image.isPrimary ? 'border-[#21A366] ring-4 ring-green-200' : 'border-gray-200'} hover:border-[#357BEB] transition-all cursor-move`} data-id="element-9912">
                            <div className="aspect-[4/3] bg-gray-200" data-id="element-9913">
                              <img src={image.url} alt={`Imagine ${index + 1}`} className="w-full h-full object-cover" data-id="element-9914" />
                            </div>
                            {image.isPrimary && <div className="absolute top-2 left-2 bg-[#21A366] text-white px-2 py-1 rounded-lg text-xs font-bold flex items-center space-x-1" data-id="element-9915">
                                <StarIcon className="w-3 h-3 fill-current" data-id="element-9916" />
                                <span data-id="element-9917">Principală</span>
                              </div>}
                            <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-9918">
                              <GripVerticalIcon className="w-5 h-5 text-white drop-shadow-lg" data-id="element-9919" />
                            </div>
                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-9920">
                              <div className="flex flex-col space-y-2" data-id="element-9921">
                                <button onClick={() => setPrimaryImage(image.id)} className="px-3 py-2 bg-white text-gray-900 rounded-lg text-xs font-semibold hover:bg-gray-100" data-id="element-9922">
                                  Setează Principală
                                </button>
                                <button onClick={() => removeImage(image.id)} className="px-3 py-2 bg-red-600 text-white rounded-lg text-xs font-semibold hover:bg-red-700" data-id="element-9923">
                                  Șterge
                                </button>
                              </div>
                            </div>
                          </div>)}
                      </div>
                    </div>}

                  <div data-id="element-9924">
                    <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-9925">
                      Link video (opțional)
                    </label>
                    <input type="url" value={formData.videoLink} onChange={e => setFormData({
                  ...formData,
                  videoLink: e.target.value
                })} placeholder="https://youtube.com/watch?v=..." className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#357BEB]" data-id="element-9926" />
                  </div>
                </div>}

              {/* STEP 8: Promotion */}
              {currentStep === 8 && <div className="space-y-6" data-id="element-9927">
                  <div data-id="element-9928">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-9929">
                      Promovare & Publicare
                    </h2>
                    <p className="text-gray-600" data-id="element-9930">
                      Selectează platformele pentru promovare
                    </p>
                  </div>

                  <div className="space-y-4" data-id="element-9931">
                    {[{
                  key: 'storiaOlx',
                  name: 'Storia & OLX',
                  color: 'from-orange-500 to-red-500',
                  emoji: '🏠'
                }, {
                  key: 'imobiliare',
                  name: 'Imobiliare.ro',
                  color: 'from-green-500 to-emerald-500',
                  emoji: '🏢'
                }, {
                  key: 'ownSite',
                  name: 'Site propriu',
                  color: 'from-purple-500 to-indigo-500',
                  emoji: '🌐'
                }].map(platform => <label key={platform.key} className="flex items-start space-x-4 p-6 bg-white rounded-xl border-2 border-gray-200 cursor-pointer hover:border-[#357BEB] transition-all" data-id="element-9932">
                        <input type="checkbox" checked={formData[platform.key as keyof typeof formData] as boolean} onChange={e => setFormData({
                    ...formData,
                    [platform.key]: e.target.checked
                  })} className="w-6 h-6 text-[#357BEB] rounded mt-1" data-id="element-9933" />
                        <div className="flex-1" data-id="element-9934">
                          <div className="flex items-center space-x-3 mb-2" data-id="element-9935">
                            <div className={`w-12 h-12 bg-gradient-to-br ${platform.color} rounded-xl flex items-center justify-center text-2xl`} data-id="element-9936">
                              {platform.emoji}
                            </div>
                            <div data-id="element-9937">
                              <h3 className="text-lg font-bold text-gray-900" data-id="element-9938">
                                {platform.name}
                              </h3>
                              <p className="text-sm text-gray-600" data-id="element-9939">
                                Platformă de anunțuri imobiliare
                              </p>
                            </div>
                          </div>
                        </div>
                        {formData[platform.key as keyof typeof formData] && <CheckCircleIcon className="w-6 h-6 text-[#21A366] flex-shrink-0" data-id="element-9940" />}
                      </label>)}
                  </div>

                  <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-6 border-2 border-green-200" data-id="element-9941">
                    <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-9942">
                      Rezumat Publicare
                    </h3>
                    <div className="space-y-2 text-sm text-gray-700" data-id="element-9943">
                      <p data-id="element-9944">
                        ✓ Anunț va fi publicat pe{' '}
                        <strong data-id="element-9945">
                          {[formData.storiaOlx, formData.imobiliare, formData.ownSite].filter(Boolean).length}{' '}
                          platforme
                        </strong>
                      </p>
                      <p data-id="element-9946">
                        ✓ Vizibilitate estimată:{' '}
                        <strong data-id="element-9947">1,000-5,000 vizualizări/lună</strong>
                      </p>
                      <p data-id="element-9948">
                        ✓ Durata: <strong data-id="element-9949">30 zile</strong> (cu opțiune
                        reînnoire)
                      </p>
                    </div>
                  </div>

                  <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6" data-id="element-9950">
                    <div className="flex items-start space-x-3" data-id="element-9951">
                      <AlertCircleIcon className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-9952" />
                      <div data-id="element-9953">
                        <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-9954">
                          Verificare finală
                        </h3>
                        <p className="text-sm text-gray-700 mb-4" data-id="element-9955">
                          Te rugăm să verifici toate datele înainte de
                          publicare. După publicare, anunțul va fi vizibil
                          public pe platformele selectate.
                        </p>
                        <div className="space-y-2" data-id="element-9956">
                          <p className="text-sm text-gray-700" data-id="element-9957">
                            <strong data-id="element-9958">Proprietate:</strong>{' '}
                            {formData.propertyType} {formData.rooms} camere,{' '}
                            {formData.zone}
                          </p>
                          <p className="text-sm text-gray-700" data-id="element-9959">
                            <strong data-id="element-9960">Preț:</strong> {formData.price}{' '}
                            {formData.currency}/lună
                          </p>
                          <p className="text-sm text-gray-700" data-id="element-9961">
                            <strong data-id="element-9962">Contact:</strong> {formData.ownerName} -{' '}
                            {formData.ownerPhone}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </motion.div>
          </AnimatePresence>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-200" data-id="element-9963">
            <button onClick={prevStep} disabled={currentStep === 1} className="flex items-center space-x-2 px-6 py-3 border-2 border-gray-300 rounded-lg font-semibold text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-9964">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-9965" />
              <span data-id="element-9966">Înapoi</span>
            </button>

            {currentStep < 8 ? <button onClick={nextStep} className="flex items-center space-x-2 px-6 py-3 bg-[#357BEB] text-white rounded-lg font-semibold hover:bg-[#2868d8] transition-colors shadow-md" data-id="element-9967">
                <span data-id="element-9968">Continuă</span>
                <ChevronRightIcon className="w-5 h-5" data-id="element-9969" />
              </button> : <div className="flex items-center space-x-3" data-id="element-9970">
                <button onClick={() => handlePublish(true)} className="flex items-center space-x-2 px-6 py-3 border-2 border-[#357BEB] text-[#357BEB] rounded-lg font-semibold hover:bg-[#357BEB] hover:text-white transition-all" data-id="element-9971">
                  <SaveIcon className="w-5 h-5" data-id="element-9972" />
                  <span data-id="element-9973">Salvează draft</span>
                </button>
                <button onClick={() => handlePublish(false)} className="flex items-center space-x-2 px-8 py-3 bg-[#21A366] text-white rounded-lg font-bold hover:bg-[#1a8555] transition-colors shadow-lg" data-id="element-9974">
                  <CheckCircleIcon className="w-5 h-5" data-id="element-9975" />
                  <span data-id="element-9976">Publică anunțul</span>
                </button>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}